import { Grid, Typography } from '@mui/material';
import React, { useContext } from 'react'
import { ThemeContext } from '../../context/ThemeContext';
import { shallowEqual, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const HistorySummary = () => {
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()
    const filteredHistory = useSelector((state) => state.history.filteredHistory, shallowEqual)
    const totalProfitLoss = filteredHistory?.reduce((total, row) => total + (row?.profitLoss || 0), 0);
    const deposit = filteredHistory.filter(row => row.type === 1).reduce((total, row) => total + (row.amount || 0), 0);
    const creditOut = filteredHistory.filter(row => row.type === 5).reduce((total, row) => total + (row.amount || 0), 0);
    const creditIn = filteredHistory.filter(row => row.type === 3).reduce((total, row) => total + (row.amount || 0), 0);
    const adjustment = filteredHistory.filter(row => row.type === 2).reduce((total, row) => total + (row.amount || 0), 0);
    const withdrawal = filteredHistory.filter(row => row.type === 4).reduce((total, row) => total + (row.amount || 0), 0);
    const selectedTabType = useSelector((state) => state.history.selectedTabType);
    const total = parseFloat((deposit + creditIn + creditOut + adjustment + withdrawal))
    console.log(selectedTabType);

    const formatted = (val) =>
        (val || 0).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    const InfoRow = ({ label, value }) => (
        <Grid item xs={6}>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <Typography variant="body2" color="text.secondary" >{t(label)}</Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>{value}</Typography>
                </Grid>
            </Grid>
        </Grid>
    );
    const infoItems = [
        // { label: 'profit', value: formatted(totalProfitLoss) },
        {
            label: selectedTabType === "Trades" ? 'P/L' : "totalAmount",
            value: formatted(selectedTabType === "Trades" ? totalProfitLoss : total),
        },
        { label: 'deposit', value: formatted(deposit) },
        { label: 'withdrawal', value: formatted(withdrawal) },
        { label: 'adjustment', value: formatted(adjustment) },
        { label: 'creditIn', value: formatted(creditIn) },
        { label: 'creditOut', value: formatted(creditOut) },
    ];

    return (
        <>
            <Grid container spacing={1} mb={1} p={1}>
                {infoItems.map((item, index) => (
                    <InfoRow key={index} label={item.label} value={item.value} />
                ))}
            </Grid>
        </>
    )
}

export default HistorySummary
